import { useEffect, useRef, ReactNode } from 'react'
import { inViewport } from '~/utils/inViewport'
import { track } from '~/utils/analytics'

interface TrackingData {
  children?: ReactNode
  event: string
  payload?: object
}

const ViewportTracking = ({ children, event, payload }: TrackingData) => {
  const viewportRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let hasTrackedView = false

    const trackViewed = () => {
      const ref = viewportRef.current
      const isInViewport = inViewport(ref)

      if (isInViewport && !hasTrackedView) {
        hasTrackedView = true
        track(event, payload)
      }
    }

    window.addEventListener('scroll', trackViewed)

    return () => {
      window.removeEventListener('scroll', trackViewed)
    }
  }, [event, payload])

  return <div ref={viewportRef}>{children}</div>
}

export default ViewportTracking
